import { Skeleton } from "@mui/material";
import useTitanApp from "../../hooks/useTitanApp";

const ActionsSkeleton = () => {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};

  const skeletonProps = {
    sx: {
      bgcolor: darkMode ? "grey.800" : "",
      "--card-bg": darkMode ? "#1E1E1E" : "#FFFFFF",
      "--card-shadow": darkMode
        ? "0px 2px 4px rgba(0, 0, 0, 0.3)"
        : "0px 2px 8px rgba(0, 0, 0, 0.1)",
    },
    animation: "wave",
    variant: "rounded",
  };

  return (
    <div className="actions-skeleton" style={skeletonProps.sx}>
      {/* First card */}
      <div className="skeleton-card">
        <Skeleton
          {...skeletonProps}
          height={40}
          width={120}
          className="skeleton-button"
        />

        <Skeleton
          {...skeletonProps}
          height={40}
          width="60%"
          className="skeleton-heading"
        />

        <Skeleton
          {...skeletonProps}
          height={24}
          width="100%"
          className="skeleton-text"
        />
        <Skeleton
          {...skeletonProps}
          height={24}
          width="100%"
          className="skeleton-text"
        />
      </div>

      {/* Second card */}
      <div className="skeleton-card">
        <Skeleton
          {...skeletonProps}
          height={40}
          width={120}
          className="skeleton-button"
        />

        <Skeleton
          {...skeletonProps}
          height={40}
          width="70%"
          className="skeleton-heading"
        />

        <Skeleton
          {...skeletonProps}
          height={24}
          width="100%"
          className="skeleton-text"
        />
        <Skeleton
          {...skeletonProps}
          height={24}
          width="100%"
          className="skeleton-text"
        />
      </div>
    </div>
  );
};

export default ActionsSkeleton;
